import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageComponent } from './language.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [LanguageComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [LanguageComponent]
})
export class LanguageModule { }
